import { TODO } from '@habity/types';

export const useServiceform = () => {
  function init(pixelId: string) {
    const window = globalThis as TODO;

    const alreadyLoaded = window.sf3pid; // This only exists when loaded
    if (alreadyLoaded) return;

    const tD = new Date().toISOString().slice(0, 10);
    window.sf3pid = pixelId; // Your pixel ID

    const url = `https://dash.serviceform.com/embed/sf-pixel.js?${tD}`;

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.async = true;

    document.head.appendChild(script);
  }

  return { init };
};
